/// Copyright (C) Microsoft Corporation. All rights reserved.

import { IValidatedMeControlConfiguration } from '@mecontrol/common';
import { load, loadAsync } from './loader';
import { SetController, publicProxy } from './publicProxy';
import { setPublicWindowApi } from './windowApi';
import { w } from './utilities';

export { meImport } from './amd';
export * from './promise';
export { getStartTime, getTimeSinceStart } from './loader';
export { logTelemetryEvent } from './logger';
export * from './utilities';
export * from './telemetry';
export { extendMe } from './windowApi';

export interface MainModule {
    init: MainInit;
}
export type MainInit = (
    options: IValidatedMeControlConfiguration | undefined,
    setController: SetController
) => void | Promise<void>;

setPublicWindowApi(publicProxy, load, loadAsync);

// Notify consumers that the Load API is ready to be called
let onLoad = w.onMeControlReadyToLoad;
// Call onLoad asynchronously
setTimeout(() => onLoad && onLoad(), 0);
